module.exports = __webpack_public_path__ + "media/sound_notification.c06c391f.mp3";